import type { House, Settlement } from '../types';
import { getGameConfig } from '../../../config/gameConfig';

const DEFAULT_HOUSE_STORAGE = {
    food: 1200,
    wood: 25,
    charcoal: 50,
};

export function createHouse(settlement: Settlement, type: House['type']): House {
    settlement.houseIdCounter += 1;
    const config = getGameConfig();
    return {
        id: `house_${settlement.id}_${settlement.houseIdCounter}`,
        type,
        people: [],
        storage: { ...DEFAULT_HOUSE_STORAGE },
        warmth: config.heat.maxWarmth[type],
    };
}

export function createHouses(
    settlement: Settlement,
    count: number,
    type: House['type'] = 'wooden',
): House[] {
    return Array.from({ length: Math.max(0, count) }, () => createHouse(settlement, type));
}
